<template>
  <div class="chart-detail-text">
    <div class="flex items-center">
      <div><div class="color-circle mr-2" :style="style"></div></div>
      <div class="aisea-text-12-400-dark-gray">{{ text }}</div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "M.ChartDetailText",
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
  },
  computed: {
    style() {
      return {
        "background-color": this.color
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.chart-detail-text {
  .color-circle {
    width: 12px;
    height: 12px;
    border-radius: 100%;
  }
}
</style>